import moment from 'moment'

// Person saldo (users-getsaldotransactions) and bank / storage (users-getstoragetransactions)
// arrive in the same shape: one entry per venue, keyed by wallet category,
//   [{ id: 'default' | <venue>, cash: [tx...], sportmoney: [tx...], minutes: [tx...] }]
// where every tx carries amount (cents, or minutes for storage 'minutes'), type,
// purchasetype, description and a 'YYYY.MM.DD HH:mm' timestamp, oldest first.

const WALLET_TITLES = {
  saldo: { cash: 'Kassasaldo', sportmoney: 'Liikuntaraha' },
  storage: { cash: 'Pankki', minutes: 'Varasto' },
}

const capitalise = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '')

export const walletUnit = (category, kind) => (kind === 'storage' && category === 'minutes' ? 'min' : '€')

// One row per (venue, category) wallet, transactions newest first.
export const walletRows = (entries, kind) => {
  if (!Array.isArray(entries)) return []
  const titles = WALLET_TITLES[kind] || {}
  const rows = []
  entries.filter(Boolean).forEach((entry) => {
    Object.keys(entry)
      .filter((category) => category !== 'id' && Array.isArray(entry[category]))
      .forEach((category) => {
        const transactions = entry[category].filter(Boolean)
        rows.push({
          key: (entry.id || 'default') + '-' + category,
          venue: entry.id || 'default',
          venueLabel: entry.id && entry.id !== 'default' ? capitalise(entry.id) : '',
          category,
          title: titles[category] || category,
          unit: walletUnit(category, kind),
          total: transactions.reduce((sum, t) => sum + (Number(t.amount) || 0), 0),
          transactions: [...transactions].reverse(),
        })
      })
  })
  return rows
}

const OTHER_LABELS = { compensation: 'Hyvitys', transfer: 'Siirto', deposit: 'Talletus' }

// The labels the Saldot tab has always used, in one place. A type it does not know is shown
// as is - it used to be dropped, which made the visible rows disagree with the balance.
export const transactionLabel = (t, kind) => {
  if (!t) return ''
  const cancelled = String(t.description || '').startsWith('Peruttu')
  if (kind === 'storage') {
    if (t.purchasetype === 'reservation') {
      if (t.type === 'refund') return cancelled ? 'Peruutus' : 'Tallennus'
      if (t.type === 'purchase') return 'Varaus'
    }
  } else if (['reservation', 'activity', 'benefitcard'].includes(t.purchasetype)) {
    if (t.type === 'refund') return cancelled ? 'Peruutus' : 'Myynti'
    if (t.type === 'purchase') return t.purchasetype === 'reservation' ? 'Varaus' : 'Maksu'
  }
  return OTHER_LABELS[t.type] || t.type || ''
}

// Cents -> '-14,00 €'; minutes -> '120 min'.
export const formatAmount = (value, unit) => {
  const n = Number(value) || 0
  if (unit === 'min') return n + ' min'
  // fi-FI writes negatives with U+2212; the rest of the app uses a plain hyphen.
  const text = (n / 100).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return text.replace('−', '-') + ' €'
}

// '2026.08.31 09:01' -> '31.8.2026 09:01'. Anything else is returned untouched.
export const formatTimestamp = (ts) => {
  const parsed = moment(ts, 'YYYY.MM.DD HH:mm', true)
  return parsed.isValid() ? parsed.format('D.M.YYYY HH:mm') : ts || ''
}
